import React from 'react'
import { connect } from 'react-redux'
import { addScript } from 'actions/site'

class LoadScript extends React.Component {
	componentDidMount() {
		const { loadedScripts, handleAddScript, src, callback } = this.props

		// Only add the script if it hasn't already been added.
		if ( loadedScripts.indexOf( src ) === -1 ) {
			// Add the script to the page.
			let tag = document.createElement( 'script' )
			tag.async = false
			tag.src = src
			tag.onload = callback
			document.getElementsByTagName( 'body' )[0].appendChild( tag )

			// Register the script as loaded.
			handleAddScript( src )
		} else if ( callback ) {
			// Always call the callback, even if script is already loaded.
			callback()
		}
	}

	render() {
		return ''
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		loadedScripts: state.site.loadedScripts
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		handleAddScript: ( src ) => {
			dispatch( addScript( src ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( LoadScript )



// WEBPACK FOOTER //
// ./components/load-script/load-script.jsx